{
  "version": 1,
  "asset_id": "09a3c98a-1d59-4240-8120-8e1aea33ff50",
  "project_id": "affbb9b7-8892-4de7-a6a3-a24f8c559459",
  "url": "/__l5e/assets-v1/09a3c98a-1d59-4240-8120-8e1aea33ff50/portico-cotto-esterno-trattato-lombardia.webp",
  "r2_key": "a/v1/affbb9b7-8892-4de7-a6a3-a24f8c559459/09a3c98a-1d59-4240-8120-8e1aea33ff50/portico-cotto-esterno-trattato-lombardia.webp",
  "original_filename": "portico-cotto-esterno-trattato-lombardia.webp",
  "size": 156930,
  "content_type": "image/webp",
  "created_at": "2026-08-13T06:52:24Z"
}
